



















































































import { status, risk } from '@/util/transformString/translationsDecorator';
import { transactionsNotAffiliated } from '@/store/interfaces/transactions';
import PaymentMethods from '@/components/Reusable/paymentMethods.vue';
import { dateTime } from '@/util/filters';
import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'DetailModal',
  components: {
    PaymentMethods,
  },
  props: {
    viewDetails: {
      type: Boolean,
      required: true,
    },
    transaction: {
      type: Object as PropType<transactionsNotAffiliated>,
      required: true,
    },
  },
  data() {
    return {
      status,
      risk,
      dateTime,
    };
  },
  computed: {
    syncedViewDetails: {
      get(): boolean {
        return this.viewDetails;
      },
      set(value: boolean) {
        this.$emit('update:viewDetails', value);
      },
    },
  },
});
